var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteamIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_266_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05915 0 0 8.05915 0 18C0 18.1641 0.00801563 18.3261 0.0121695 18.4895L8.76202 21.5589C9.77487 20.2394 11.3622 19.3846 13.1538 19.3846C13.2798 19.3846 13.4031 19.3952 13.527 19.4035L15.965 15.0158C15.9373 14.7451 15.9231 14.4706 15.9231 14.1923C15.9231 9.79546 19.4878 6.23077 23.8846 6.23077C28.2815 6.23077 31.8462 9.79546 31.8462 14.1923C31.8462 18.5892 28.2815 22.1538 23.8846 22.1538C23.4492 22.1538 23.0256 22.1101 22.6095 22.043L18.672 24.5039C18.6817 24.6431 18.6923 24.7812 18.6923 24.9231C18.6923 27.9817 16.2125 30.4615 13.1538 30.4615C10.0952 30.4615 7.61538 27.9817 7.61538 24.9231C7.61538 24.7445 7.62581 24.5688 7.64243 24.3944L0.225811 20.8477C1.59104 29.435 9.02839 36 18 36C27.9408 36 36 27.9408 36 18C36 8.05915 27.9408 0 18 0ZM23.8846 9C21.0171 9 18.6923 11.3248 18.6923 14.1923C18.6923 17.0598 21.0171 19.3846 23.8846 19.3846C26.7522 19.3846 29.0769 17.0598 29.0769 14.1923C29.0769 11.3248 26.7522 9 23.8846 9ZM23.8846 11.7692C25.2228 11.7692 26.3077 12.8541 26.3077 14.1923C26.3077 15.5305 25.2228 16.6154 23.8846 16.6154C22.5464 16.6154 21.4615 15.5305 21.4615 14.1923C21.4615 12.8541 22.5464 11.7692 23.8846 11.7692ZM13.1538 21.4615C12.2912 21.4615 11.513 21.7887 10.9066 22.3107L13.285 23.145C14.0306 23.379 14.5385 24.0698 14.5385 24.8514C14.5385 26.1682 13.1641 27.0356 11.9761 26.4672L9.74099 25.3977C9.9736 27.0828 11.4044 28.3846 13.1538 28.3846C15.0653 28.3846 16.6154 26.8345 16.6154 24.9231C16.6154 23.0116 15.0653 21.4615 13.1538 21.4615Z",
    fill: "url(#paint0_linear_266_132)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_266_132",
    x1: 2.42537,
    y1: 4.70251,
    x2: 36.0088,
    y2: 12.0243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_266_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamIcon);
export default __webpack_public_path__ + "static/media/Steam-icon.6d8d68695de9122d0a261054e34a5d7a.svg";
export { ForwardRef as ReactComponent };